import { forwardRef, useImperativeHandle } from "react"

export interface DownloadAppModalHandle {
  openModal: () => void
  closeModal: () => void
}

const DownloadAppModal = forwardRef<DownloadAppModalHandle>((_, ref) => {
  // Expose methods to parent via ref for compatibility
  useImperativeHandle(ref, () => ({
    openModal: () => {
      // No-op: removed download modal functionality
    },
    closeModal: () => {
      // No-op: removed download modal functionality
    },
  }))

  // Removed download app modal - no longer encouraging app downloads
  return null
})

export default DownloadAppModal
